import React from 'react'
import { MenuItem, Typography } from '@material-ui/core'
import { SelectFormsy } from '@fuse'
import { useIntl } from 'react-intl'

const genderList = ['Male', 'Female', 'Other']

export default (props) => {
  const { label, name, value } = props
  const { formatMessage } = useIntl()

  return (
    <SelectFormsy
      className="w-full"
      name={name}
      label={formatMessage({ id: label })}
      value={value}
      variant="standard"
    >
      {genderList.map((item, index) => {
        return (
          <MenuItem key={index} value={item}>
            <Typography>{item}</Typography>
          </MenuItem>
        )
      })}
    </SelectFormsy>
  )
}
